export function showDebugToast(message: string, duration = 3000) {
  // Create the toast container if it doesn't exist
  let container = document.getElementById('toast-container');

  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-container';
    container.style.position = 'fixed';
    container.style.bottom = '20px';
    container.style.right = '20px';
    container.style.zIndex = '9999';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '10px';
    document.body.appendChild(container);
  }

  // Create the toast element
  const toast = document.createElement('div');

  toast.textContent = `GA4 Action: ${message}`;
  toast.style.background = 'rgba(0, 0, 0, 0.8)';
  toast.style.color = '#fff';
  toast.style.padding = '10px 20px';
  toast.style.borderRadius = '4px';
  toast.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
  toast.style.fontFamily = 'sans-serif';
  toast.style.fontSize = '14px';
  toast.style.opacity = '0';
  toast.style.transition = 'opacity 0.3s ease';

  // Append and fade in
  container.appendChild(toast);
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
  });

  // Timeout and pause logic
  let remaining = duration;
  let timeoutId: NodeJS.Timeout;
  let startTime = Date.now();

  const startTimer = () => {
    startTime = Date.now();
    timeoutId = setTimeout(() => {
      toast.style.opacity = '0';
      toast.addEventListener('transitionend', () => {
        toast.remove();

        if (container?.children.length === 0) {
          container.remove();
        }
      });
    }, remaining);
  };

  const pauseTimer = () => {
    clearTimeout(timeoutId);
    remaining -= Date.now() - startTime;
  };

  toast.addEventListener('mouseenter', pauseTimer);
  toast.addEventListener('mouseleave', startTimer);

  startTimer();
}
